module.exports = __webpack_public_path__ + "img/setting.06003a9c.png";